<template>
  <div class="single-article-card" ref="single-article-card">
    <b-skeleton
        size="is-large"
        height="100px"
        :active="!dispMounted"
    ></b-skeleton>

    <div :id="parseCordArt(cod_art)" v-if="dispMounted">

      <div class="specs">
        <ul>
          <li class="celle-datasheet" :class="(datasheet.length <= 7) ? 'by-7' : 'by-8'">
            <strong id="cod_art">{{ cod_art }}</strong>
            <!--            <small>{{des_art}}</small>-->
          </li>
          <li class="celle-datasheet" :class="(datasheet.length <= 7) ? 'by-7' : 'by-8'" v-for="d in datasheet"
              v-if="totalLabels.includes(d.id_ref_etichetta)">
            <etichetta class="etichette-mobile" :etichetta="d.id_ref_etichetta"/>
            <span>{{ d.contenuto }}</span>
          </li>

        </ul>
      </div>
      <div class="riga-disponibilita">
        <div :class="disponibilita > 0 ? 'disponibilita available' : 'disponibilita unavailable'">
        <img :src="disponibilita > 0 ? url('/media/icons/available.svg') : url('/media/icons/unavailable.svg')"
             :alt="disponibilita"/>
        <span>{{ trans.get("b2b.article.availability") }} {{ disponibilita }} {{ unitaMisuraLong }}</span>
      </div>
      <div v-if="storicoAcquistato && priceFound" class="storico-acquistato">
        <div class="storico-acquistato-desktop" v-if="widthComponent >= 1200">
          <span :class="(st.anno === currentYear()) ? 'current-year' : ''"
                v-for="st in storicoAcquistato">{{trans.get('generals.article.history.year')}}: {{ st.anno }} - {{trans.get('generals.article.history.purchased')}}: {{ st.acquistato }}</span>
        </div>
        <div class="storico-acquistato-mobile" v-if="widthComponent < 1200">
          <img :src="url('/storage/media/icons/png/storico-ordini.png')" alt="storico ordini">
          <div class="popup">
            <ul>
              <li :class="(st.anno === currentYear()) ? 'current-year' : ''" v-for="st in storicoAcquistato"> {{trans.get('generals.article.history.year')}}: {{ st.anno }}: {{st.anno}} - {{trans.get('generals.article.history.purchased')}}: {{st.acquistato}}  </li>
            </ul>
          </div>
        </div>
      </div>
      </div>

      <div class="shop">
        <div class="prezzi">

          <price-elm v-if="currentUser" :cod_art="cod_art" :unita_misura="unita_misura" :current_user="currentUser" @prezzi="fetchPrezzi"
                     @unita-misura="fetchUnitaMisura" @storicoAcquistato="fetchStoricoAcquistato"/>
        </div>
        <div class="sel-quantita">
          <p>{{ trans.get("b2b.article.quantity") }} ({{ unitaMisura }})</p>
          <b-field>
            <b-numberinput
                :step="qtaimballo"
                :min="qtaimballo"
                v-model="currentQuantita"
                :disabled="!priceFound"
                type="is-dark"
            ></b-numberinput>
          </b-field>
        </div>
        <div class="add-cart">
          <a v-if="priceFound" class="link-ret green" @click="addToCart">
            <img :src="url('/media/icons/svg/cart1.svg')" alt="cart icon"/>
            {{ trans.get("b2b.article.add-cart") }}
          </a>
          <a v-else class="link-ret disabled">
            <img :src="url('/media/icons/svg/cart1.svg')" alt="cart icon"/>
            {{ trans.get("b2b.article.add-cart") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import etichetta from "./etichetta";

export default {
  components: {
    etichetta
  },
  name: "single-art-card",
  props: [
    "cod_art",
    "des_art",
    "datasheet",
    "qtaimballo",
    "currentUser",
    "currentRole",
    "chiave",
    "totalLabels",
    'unita_misura',
  ],
  data: function () {
    return {
      //100-1 sezione
      //100-2 peso
      //100-3 pretensione cons
      //100-4 forza pretensione
      //100-5 carico max
      //100-6 diametro min
      //100-7 lunghezza imballo
      unitaMisura: null,
      isLoaded: false,
      disponibilita: null,
      dispMounted: false,
      currentQuantita: this.qtaimballo,
      prezzi: [],
      priceFound: null,
      unitaMisuraLong: null,
      storicoAcquistato: null,
      widthComponent: null,
    };
  },
  mounted() {
    this.getGiacenza(this.cod_art);
    console.log(this.$refs["single-article-card"].clientWidth)
    this.widthComponent = this.$refs["single-article-card"].clientWidth
  },

  methods: {
    currentYear() {
      let data = new Date()
      return data.getFullYear()
    },
    fetchStoricoAcquistato(values) {
      this.storicoAcquistato = values
    },
    fetchUnitaMisura(values) {
      this.unitaMisura = values
      if (this.unitaMisura === 'Mt') {
        this.unitaMisuraLong = this.$trans('b2b.prices.meters')
      } else {
        this.unitaMisuraLong = this.$trans('b2b.prices.pieces')
      }
    },
    fetchPrezzi(values) {
      //console.log(values)
      this.priceFound = values.priceFound
      if (values.scaglioni !== null) {
        this.prezzi = values.scaglioni
      }
    },
    addToCart: function () {
      let prezzo = this.prezzi[0].prezzoNetto
      if (this.prezzi.length > 1) {
        length = this.prezzi.length
        if (this.currentQuantita < this.prezzi[length - 2].qta) { // < 99
          prezzo = this.prezzi[0].prezzoNetto
        } else if (this.currentQuantita >= this.prezzi[length - 2].qta && this.currentQuantita < this.prezzi[length - 1].qta) { // >= 100 < 499
          prezzo = this.prezzi[1].prezzoNetto
        } else if (this.currentQuantita >= this.prezzi[length - 1].qta) { // >= 500
          prezzo = this.prezzi[2].prezzoNetto
        }
      }
      this.$store.dispatch("addItemToCart", {
        codart: this.cod_art,
        quantita: this.currentQuantita,
        prezzo: this.currentQuantita * prezzo,
        prezzo_unitario: prezzo,
      });
      //this.$store.dispatch("refreshCart");
      // this.$buefy.toast.open({
      //   message: `Articoli aggiunti correttamente al carrello!`,
      //   duration: 5000,
      //   type: "is-success",
      // });
      this.$store.commit("openCart");
    },
    /*getPrices: function (codart, user) {
      axios({
        method: "post",
        url: window.location.origin + "/b2b/prezzi",
        params: {
          codart: codart,
          codcliente: user,
        },
      })
          .then((res) => {
            if (res.data[0].scaglioni.length !== 0) {
              this.prezzi = res.data[0].scaglioni;
            } else {
              this.prezzi.push({
                prezzoNetto: parseFloat("1"),
              });
            }
          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },*/
    getGiacenza: function (codart) {
      axios({
        method: "get",
        url: window.location.origin + "/b2b/giacenze",
        params: {
          codart: codart,
        },
      })
          .then((res) => {
            this.disponibilita = res.data[0].disponibilita;
            this.dispMounted = true;
            //this.getPrices(this.cod_art, this.currentUser);
            this.$emit("loaded", this.chiave);
          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
    parseCordArt: function (codart) {
      codart = codart.replace(/,/g, "");
      return codart.replace(/ /g, "");
    },
    openShop: function (cod_art) {

      cod_art = this.parseCordArt(cod_art);
      //  console.log(cod_art)
      if (this.currentRole <= 2) {
        if (this.disponibilita > 0) {
          let checkbox = $("#" + cod_art).children("input");
          checkbox.prop("checked", !checkbox.prop("checked"));
          let shop = $("#" + cod_art).children(".shop");

          if (checkbox.prop("checked")) {
            shop.addClass("show");
          } else {
            shop.removeClass("show");
          }
        } else {
          let checkbox = $("#" + cod_art).children("input");
          checkbox.prop("disabled", true);
        }
      } else {
        let checkbox = $("#" + cod_art).children("input");
        checkbox.prop("disabled", true);
      }
    },
    openShop2: function (cod_art) {
      cod_art = this.parseCordArt(cod_art);
      if (this.currentRole <= 2) {
        if (this.disponibilita > 0) {
          let checkbox = $("#" + cod_art).children("input");
          let shop = $("#" + cod_art).children(".shop");
          if (checkbox.prop("checked")) {
            shop.addClass("show");
          } else {
            shop.removeClass("show");
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.single-article-card {
  background-color: #f5f5f5;
  padding-top: 17px;
  padding-bottom: 25px;
  #cod_art {
    white-space: nowrap;
  }
  p {
    margin-top: 28px;
  }

  input[type="checkbox"] {
    float: left;
    margin-top: 5px;
    margin-left: 21px;
    transform: scale(1.5);
  }

  .specs {
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    small {
      font-size: 10px;
      display: block;
    }

    ul {
      padding-left: 5px;
      width: 100%;
      display: flex;
      flex-direction: column;

      li {
        text-align: right;
        width: 100%;
        display: flex;
        justify-content: space-between;
        @media (max-width: 576px){
          justify-content: center;
        }
        span {
          display: inline-block;
          text-align: left;
          margin-right: 10px;
        }

        &.diametro,
        &.peso {
          width: 100%;
        }
      }
    }
  }

  .etichette-mobile {
    display: none !important;
    @media (max-width: 576px) {
      display: inline !important;
    }
  }
  .riga-disponibilita {
    width: 100%;
    display: flex;
    align-items: center;
    @media (max-width: 576px) {
      justify-content: space-around;
    }
    .disponibilita {
      padding-left: 59px;
      display: inline-block;
      @media (max-width: 576px) {
        padding-left: 0;
      }
      img {
        display: inline-block;
        margin-right: 12px;
      }

      &.available {
        color: #23b371;
      }

      &.unavailable {

      }

    }

    .storico-acquistato {
      display: inline-block;
      margin-left: 50px;
      @media (max-width: 576px) {
        margin-left: 0;
      }
      .storico-acquistato-desktop {
        width: 100%;
        display: flex;
        span {
          color: #0000ff;
          margin-right: 50px;
          &.current-year {
            color: #ff0044;
          }
        }

      }

      .storico-acquistato-mobile {
        display: inline-block;
        color: black;
        position: relative;

        .popup {
          display: none;
          position: absolute;
          background-color: white;
          box-shadow: 5px 5px 4px -2px rgba(112,112,112,0.59);
          bottom: 100%;
          left: 50%;
          padding: 10px;
          border-radius: 5px;
          @media (max-width: 576px) {
            right: 0;
            left: unset;
          }
          ul {
            display: flex;
            flex-direction: column;
            align-items: center;
            li {
              color: #169bff;
              white-space: nowrap;

              &.current-year {
                color: #ff0044;
              }
            }
          }

        }

        &:hover .popup {
          display: block;
        }
      }
    }
  }


  .shop {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    &.show {
      display: flex;
    }

    .prezzi {
      width: 25%;
      height: 100%;
      @media (max-width: 576px) {
        margin-top: 20px;
        width: 50%;
      }
    }

    .sel-quantita {
      width: 40%;
      @media (max-width: 576px) {
        width: 100%;
      }

      p {
        margin-bottom: 15px;
        justify-content: center;
      }

      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      height: 100%;
    }

    .add-cart {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: flex-end;
      width: 50%;
      margin-top: 20px;
      @media (max-width: 576px) {
        width: 100%;
      }

      a {
        width: 394px;
        height: 56px;
        max-width: none;


        img {
          width: 28px;
          filter: brightness(0);
          margin: 0 31px;
        }
      }
    }
  }
}

@media (min-width: 576px) {
  .a-capo {
    display: none;
  }
  .single-article-card {
    background-color: #f5f5f5;
    padding-top: 17px;
    padding-bottom: 25px;

    p {
      margin-top: 28px;
    }

    input[type="checkbox"] {
      float: left;
      margin-top: 5px;
      margin-left: 21px;
      transform: scale(1.5);
    }

    .specs {
      cursor: pointer;
      display: flex;
      align-items: center;

      ul {
        //padding-left: 50px;
        width: 100%;
        display: flex;
        flex-direction: row;

        li {
          text-align: center;
          display: initial;

        }
      }

      .celle-datasheet {
        &.by-7 {
          width: calc(100% / 7);
        }

        &.by-8 {
          width: calc(100% / 8);
        }
      }
    }

    .shop {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      flex-direction: row;

      .prezzi {
        width: 20%;
        margin-left: 50px;
      }

      .sel-quantita {
        width: 30%;

      }

      .add-cart {
        margin-right: 15px;
        width: 50%;
        margin-top: 0;
      }
    }
  }
}
</style>
